import { Pipe, PipeTransform } from '@angular/core';
import { User } from '../models/user';

@Pipe({
  name: 'searchUser'
})
export class SearchUserPipe implements PipeTransform {

  transform(users: User[], searchText: string): unknown {
    return searchText ? users.filter(user => {
      return user.username && user.username.toLowerCase().includes(searchText.toLowerCase())
      || user.email && user.email.toLowerCase().includes(searchText.toLowerCase())
      || user.name.toLowerCase().includes(searchText.toLowerCase())
    }) : users;
  }

}
